import React from "react";
import { alpha } from "@mui/material";
import { MotionBox } from "@rusha/shared-theme";
import CodeIcon from "@mui/icons-material/Code";
import MemoryIcon from "@mui/icons-material/Memory";
import DataObjectIcon from "@mui/icons-material/DataObject";
import CloudIcon from "@mui/icons-material/Cloud";
import type { Theme } from "@mui/material/styles";
import {
  floatIcon1Animate,
  floatIcon1Transition,
  floatIcon2Animate,
  floatIcon2Transition,
  floatIcon3Animate,
  floatIcon3Transition,
  floatIcon4Animate,
  floatIcon4Transition,
} from "./HeroAnimations";

interface HeroBackgroundProps {
  theme: Theme;
}

const HeroBackground: React.FC<HeroBackgroundProps> = ({ theme }) => (
  <>
    <MotionBox
      sx={{
        position: "absolute",
        top: "15%",
        left: "10%",
        color: "primary.light",
        zIndex: 0,
        opacity: 0.6,
        display: { xs: "none", md: "block" },
        filter: `drop-shadow(0 0 8px ${alpha(theme.palette.primary.main, 0.4)})`,
      }}
      animate={floatIcon1Animate}
      transition={floatIcon1Transition}
    >
      <CodeIcon sx={{ fontSize: 50 }} />
    </MotionBox>

    <MotionBox
      sx={{
        position: "absolute",
        bottom: "20%",
        right: "15%",
        color: "secondary.light",
        zIndex: 0,
        opacity: 0.6,
        display: { xs: "none", md: "block" },
        filter: `drop-shadow(0 0 8px ${alpha(theme.palette.secondary.main, 0.4)})`,
      }}
      animate={floatIcon2Animate}
      transition={floatIcon2Transition}
    >
      <MemoryIcon sx={{ fontSize: 60 }} />
    </MotionBox>

    <MotionBox
      sx={{
        position: "absolute",
        top: "40%",
        right: "30%",
        color: "primary.main",
        zIndex: 0,
        opacity: 0.5,
        display: { xs: "none", md: "block" },
        filter: `drop-shadow(0 0 8px ${alpha(theme.palette.primary.main, 0.3)})`,
      }}
      animate={floatIcon3Animate}
      transition={floatIcon3Transition}
    >
      <DataObjectIcon sx={{ fontSize: 45 }} />
    </MotionBox>

    <MotionBox
      sx={{
        position: "absolute",
        top: "65%",
        left: "25%",
        color: "secondary.main",
        zIndex: 0,
        opacity: 0.5,
        display: { xs: "none", md: "block" },
        filter: `drop-shadow(0 0 8px ${alpha(theme.palette.secondary.main, 0.3)})`,
      }}
      animate={floatIcon4Animate}
      transition={floatIcon4Transition}
    >
      <CloudIcon sx={{ fontSize: 40 }} />
    </MotionBox>
  </>
);

export default HeroBackground;
